import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { ENTITLEMENTS } from '../../application-core/constants';
import { UserConsumer } from '../../core/providers/UserProvider';
import { globalStyles as styles } from '../../core/style/gstheme';
import { ENTITLEMENTS as APPENTITLEMENTS, MODULES } from '../../core/utils/constants';
import { checkEntitlements, isModuleActivated } from '../../core/utils/utils';
import ApplicationCard from './ApplicationCard';

// What is the minimum permissions needs to see the application in the dashboard?
const appEntitlements = {
  ontologymanager: [
    ENTITLEMENTS.VIEW_ONTOLOGY
  ],
  vocabularymanager: [
    ENTITLEMENTS.VIEW_TAXONOMY
  ],
  datamanager: [
    ENTITLEMENTS.VIEW_DATASET
  ],
  navigator: [
    "https://graphifi.com/schema/entitlement/viewNavigator"
  ]
};

class Applications extends React.Component {

  render() {

    const { applications, classes, modules } = this.props;

    return (
      <UserConsumer>
        {({ entitlements, user, activeSubscription }) => {
          return <Grid spacing={2}
            container
            role="main"
            justifyContent="space-evenly"
            data-test="application-choices"
            classes={
              {
                "spacing-xs-2": classes.fullGrid
              }
            }>
            {applications && activeSubscription && applications.map((application) => {
              const entitlement = appEntitlements[application.applicationURL.substring(1)];
              if (checkEntitlements(entitlements, entitlement)) {
                let activated = "requiresModule" in application ? isModuleActivated(modules, MODULES.DATA_MANAGER) : true;
                return <Grid key={application.id} item>
                  <ApplicationCard
                    dataTest={application.id}
                    key={application.id}
                    id={application.id}
                    url={application.applicationURL}
                    title={application.label.en}
                    description={application.description.en}
                    activated={activated}
                    thumbnail={application.applicationThumbnail}
                  />
                </Grid>;
              }
              else return null;
            }
            )}
            {checkEntitlements(entitlements, [
              APPENTITLEMENTS.MANAGE_INTEGRATION,
              APPENTITLEMENTS.MANAGE_SETTINGS,
              APPENTITLEMENTS.MANAGE_SNAPSHOTS,
              APPENTITLEMENTS.CAN_QUERY,
              APPENTITLEMENTS.EDIT_USER,
              APPENTITLEMENTS.CREATE_GROUP,
              APPENTITLEMENTS.EDIT_GROUP
            ]
            ) ?
              <Grid item>
                <ApplicationCard
                  dataTest="dashboard-card"
                  id="dashboard"
                  url="/dashboard"
                  title="Dashboard"
                  description="Manage users, groups, snapshots, integrations, run SPARQL and control settings."
                  thumbnail="/images/dashboard.svg"
                />
              </Grid>
              :
              null
            }
            {(user.systemAdmin || user.superAdmin) &&
              <Grid item>
                <ApplicationCard
                  dataTest="administration-card"
                  id="administration"
                  url="/administration"
                  title="System Administration"
                  description="Manage the system."
                  thumbnail="/images/dashboard.svg"
                />
              </Grid>
            }
            <Grid item>
              <ApplicationCard
                dataTest="account-card"
                id="account"
                url="/account"
                title="Account"
                description="Manage your account details and subscriptions."
                thumbnail="/images/users.svg"
              />
            </Grid>
            <Grid item>
              <ApplicationCard
                dataTest="manual-card"
                url="/docs"
                isManagedUrl={false}
                title="User Manual"
                description="Complete documentation on how to use the applications."
                thumbnail="/images/user-manual.svg"
              />
            </Grid>
          </Grid>;
        }}
      </UserConsumer>
    );
  }
}

Applications.propTypes = {
  classes: PropTypes.object,
  modules: PropTypes.number,
  applications: PropTypes.array
};

export default withStyles(styles)(Applications);